<template>
   <div>
    <template v-for="(pData, pKey) in pdfLinkCovData">
    <div class="row mx-0 mb-1 smaller-font-content" :key="pKey">
        <div v-if="pData.values.length > 0" class="col-6 col-sm-3 font-weight-bold">{{pData.label}}</div>
        <div class="col-6 col-sm-9" v-for="(buttonData, bKey) in pData.values" :key="bKey">
            <div>
                <button class="btn cov-red-btn" @click="redirectToCoverage(buttonData.internal_value)">{{buttonData.display_value}}</button>
            </div>
        </div>
    </div>
    </template>
    </div>
</template>

<script>
export default {
  props: ['pdfLinkCovData'],
  methods: {
    redirectToCoverage(redUrl) {
      window.open(redUrl, '_blank');
    },
  },
};
</script>

<style>
.cov-red-btn{
  border: 1px solid #003366 !important;
  padding-top: 5px !important;
  height: 30px !important;
}
.cov-red-btn:hover{
  background-color: #003366 !important;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputLinkButtonList.vue?54a882fc